import React from 'react';
import PropTypes from 'prop-types'

const sizes = {
  small: ['12px', '12px'],
  middle: ['16px', '16px'],
  large: ['32px', '32px'],
  huge: ['64px', '64px'],
};

const StarIcon = (props) => {
  const width = sizes[props.size][0];
  const height = sizes[props.size][1];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      style={{
        ...(props.shouldPadding
          ? {
              padding: '4px',
            }
          : {}),
      }}
    >
      <path
        fill="#f2d600"
        d="m12 .587 3.668 7.568L24 9.306l-6.064 5.828 1.48 8.279L12 19.446l-7.417 3.967 1.481-8.279L0 9.306l8.332-1.151z"
      />
    </svg>
  );
};

StarIcon.propTypes = {
  size: PropTypes.string,
  shouldPadding: PropTypes.bool,
};
StarIcon.defaultProps = {
  size: 'middle',
  shouldPadding: false,
};


export default StarIcon;
